import Auth from 'works/legacy/lib/auth';

type PaginationState = {
  limit: number;
  offset: number;
  orderDirection?: string;
  orderField?: string;
  pageSize?: number;
  current?: number;
};

type PaginationStorage = Record<string, PaginationState>;

function loadFromStorage(localStorageKey: string): PaginationStorage {
  try {
    const raw = localStorage.getItem(localStorageKey);
    return raw ? (JSON.parse(raw) as PaginationStorage) : {};
  } catch {
    console.error(`Error parsing pagination for key "${localStorageKey}"`);
    return {};
  }
}

export function getPaginationFromStorage(
  localStorageKey: string
): PaginationState | null {
  const membershipId = Auth.membershipId();
  if (!membershipId) return null;

  const stored = loadFromStorage(localStorageKey);
  return stored[membershipId] ?? null;
}

export function savePaginationToStorage(
  localStorageKey: string,
  paginationData: PaginationState
): void {
  const membershipId = Auth.membershipId();
  if (!membershipId) return;

  const stored = loadFromStorage(localStorageKey);
  localStorage.setItem(
    localStorageKey,
    JSON.stringify({ ...stored, [membershipId]: paginationData })
  );
}
